import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-driver",
  "use": "icon-driver-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-driver\"><path d=\"M512 450.048a216.576 216.576 0 0 0 204.8-224.768A216.576 216.576 0 0 0 512 0a216.576 216.576 0 0 0-204.8 224.768 216.576 216.576 0 0 0 204.8 224.768z m-24.064 328.192l190.464-274.944A650.24 650.24 0 0 0 512 481.28a531.968 531.968 0 0 0-242.688 47.104s-15.36 0-45.568 51.2c-46.08 76.288-117.248 187.904-137.728 225.28-14.848 24.576-51.2 73.216-27.648 124.928A492.544 492.544 0 0 0 116.736 1024h114.176a263.68 263.68 0 0 1 256-245.76z m450.048 25.6c-35.328-61.44-113.152-185.856-119.296-197.12s-33.792-70.656-81.92-86.016l-19.968-6.144-182.272 263.68a265.216 265.216 0 0 1 260.608 245.76h102.4s11.264 0 65.536-99.328c20.48-51.2 0-75.776-26.624-120.832z m-425.984 39.424C391.68 843.264 294.4 921.6 294.4 1024h435.2c0-102.4-97.28-180.736-217.6-180.736z\" fill=\"#ffffff\" p-id=\"6825\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/driver.svg
// module id = LIUC
// module chunks = 66